/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import BSNavItem from "react-bootstrap/NavItem";
import FAIcon from "react-fa";
import PropTypes from "prop-types";
import React, {Component} from "react";

export default class NavBackToMain extends Component {
  static contextTypes = {
    __: PropTypes.func.isRequired,
  };

  render() {
    const {
      __,
    } = this.context;

    return (
      <BSNavItem href="/">
        <FAIcon name="home" />
        <FAIcon name="level-up" />
        {` ${__("oa-settings::menu.backToMain")}`}
      </BSNavItem>
    );
  }
}



// WEBPACK FOOTER //
// ../render/components/NavBackToMain.jsx